module.exports = __webpack_public_path__ + "img/1p.0d6ec72f.png";